export default function AppInstallBannerCtrl($localstorage) {
  var vm = this;
  var ua = navigator.userAgent || '';
  vm.isIos = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
  vm.isAndroid = /android/i.test(ua);
  vm.iosLink = 'https://apps.apple.com/us/app/egg-clearinghouse/id1021265129';
  vm.androidLink = 'https://play.google.com/store/apps/details?id=org.eggs.eci.trading';
  vm.dismissed = $localstorage.get('app-install-banner-dismissed') === '1';
  vm.dismiss = function () {
    vm.dismissed = true;
    $localstorage.set('app-install-banner-dismissed', '1');
  };
}
